import format from "date-fns/format";
import { DEFAULT_SHEET_NAME } from "../constants";
import type { TemplatesValue } from "../types";
import {
  GrantTerm,
  GrantedArea,
  NameLowercase,
  Note,
  PersonalId,
  Regency,
  Sex,
  Team,
} from "./_fields";

type SecurityControlLongTermProvideTemplate = {
  unit: string;
  name: string;
  sex: string;
  personalId: number;
  regency: string;
  grantTerm: string;
  grantedArea: string;
  note: string;
};

export const securityControlLongTermProvideTemplate: TemplatesValue<SecurityControlLongTermProvideTemplate> =
  {
    fileName: "DanhSachNhanVienDaiHanCapMoi",
    sheet: DEFAULT_SHEET_NAME,
    structures: [
      {
        ...Team,
        header: "Đơn vị",
      },
      NameLowercase,
      Sex,
      PersonalId,
      Regency,
      {
        ...GrantTerm,
        value: `${format(new Date(), "d/M/yyyy")} - ${format(new Date(), "d/M/yyyy")}`,
      },
      {
        ...GrantedArea,
        header: "Khu vực được cấp",
      },
      Note,
    ],
    fields: ["unit", "name", "sex", "personalId", "regency", "grantTerm", "grantedArea", "note"],
  };
